// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_Kvr","cls2":"LoswpPackPitch-cls2_gkY LoswpPackPitch-cls1_Kvr"};